import React from 'react'
import style from '../assets/scss/emailmodal.module.scss'
import { useEmailSent } from '../context/EmailSentContext'

const EmailSentModal = () => {

    const {shouldShowModal} = useEmailSent()

    if(!shouldShowModal){
        return null
    }

    return (
        <div className={style.content}>
            <p className={style.text}>Email enviado com sucesso!</p>
        </div>
    )
}

export default EmailSentModal